/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { AnyAction as ReduxAction } from 'redux';
import type {
	DynamicFlagMessage,
	DynamicFlagMessageValues,
	Flag as BaseFlag,
	FlagAction,
	FlagComponent,
	FlagComponentProps,
	FlagComponentDefaultProps,
	FlagConfiguration as BaseFlagConfiguration,
	FlagCustom,
	FlagCustomRenderProps,
	FlagId,
	FlagMessage,
	FlagServiceHook as BaseFlagServiceHook,
	FlagType,
	ShowFlagFn as BaseShowFlagFn,
} from '@af/jira-flags-types';
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl-v2
import type { MaybeChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl-v2
import type { Store as StoreTangerine } from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl-v2
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Action = ReduxAction;

export type Store<TState> = StoreTangerine<TState>;

// ==============
// === public ===
// ==============

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type {
	// eslint-disable-next-line jira/export/restrict-types-re-export
	DynamicFlagMessage,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	DynamicFlagMessageValues,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagAction,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagComponent,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagComponentProps,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagComponentDefaultProps,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagCustom,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagCustomRenderProps,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagId,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagMessage,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	FlagType,
};

export type FlagConfiguration = BaseFlagConfiguration<
	MessageDescriptor,
	MaybeChoreographedComponentProps
>;

export const DISMISS_COMMAND = 'DISMISS' as const;

export type DismissFlag = {
	id: FlagId;
	command: typeof DISMISS_COMMAND;
};

/* eslint-disable-next-line no-new-wrappers */ // @ts-expect-error - TS2322 - Type 'String' is not assignable to type 'string'.
export const toFlagId = (flagId: string | number): FlagId => new String(flagId);
export const fromFlagId = (flagId: FlagId): string => flagId.valueOf();

export type Flag = BaseFlag<MessageDescriptor, MaybeChoreographedComponentProps>;
export type ShowFlag = Flag;

export type ShowFlagFn = BaseShowFlagFn<MessageDescriptor, MaybeChoreographedComponentProps>;
export type FlagServiceHook = BaseFlagServiceHook<
	MessageDescriptor,
	MaybeChoreographedComponentProps
>;

export type FlagService = {
	showFlag: ShowFlagFn;
	dismissFlag: (arg1: DismissFlag) => void;
};

// =================================
// === public: redux integration ===
// =================================

export type FlagsMapper<TAction extends Action, TState> = (
	action: TAction,
	state: TState,
) => Flag | DismissFlag | undefined;

type DismissFlagFunction = (arg1: FlagId) => DismissFlag;
export type ToFlagIdFunction = (arg1: string) => FlagId;

export type FlagsMapperFactoryArguments = {
	dismissFlag: DismissFlagFunction;
	toFlagId: ToFlagIdFunction;
};

export type FlagsMapperFactory<T extends Action, S> = (
	arg1: FlagsMapperFactoryArguments,
) => FlagsMapper<T, S>;

export type FlagsDispatcherFactoryProps<T extends Action, S> = {
	mapperFactory: FlagsMapperFactory<T, S>;
};

// ================
// === internal ===
// ================

export type FlagInstanceId = string | number;

export type FlagInstance = {
	id: FlagInstanceId;
	flag: Flag;
};
